import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function FCliente({ usuario }) {
    const [clientes, setClientes] = useState([]);
    const [clientesFiltrados, setClientesFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);

    // Datos para los selectores
    const [gruposCliente, setGruposCliente] = useState([]);
    const [paises, setPaises] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [ciudadesFiltradas, setCiudadesFiltradas] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [zonasVendedor, setZonasVendedor] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [listasPrecio, setListasPrecio] = useState([]);
    const [formasPago, setFormasPago] = useState([]);
    const [cadenas, setCadenas] = useState([]);
    const [canales, setCanales] = useState([]);
    const [tiposCliente, setTiposCliente] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [sucursales, setSucursales] = useState([]);

    // Estados de selectores activos
    const [grupoClienteSeleccionado, setGrupoClienteSeleccionado] = useState(null);
    const [paisSeleccionado, setPaisSeleccionado] = useState(null);
    const [ciudadSeleccionada, setCiudadSeleccionada] = useState(null);
    const [zonaSeleccionada, setZonaSeleccionada] = useState(null);
    const [zonaVendedorSeleccionada, setZonaVendedorSeleccionada] = useState(null);
    const [vendedorSeleccionado, setVendedorSeleccionado] = useState(null);
    const [listaPrecioSeleccionada, setListaPrecioSeleccionada] = useState(null);
    const [formaPagoSeleccionada, setFormaPagoSeleccionada] = useState(null);
    const [cadenaSeleccionada, setCadenaSeleccionada] = useState(null);
    const [canalSeleccionado, setCanalSeleccionado] = useState(null);
    const [tipoClienteSeleccionado, setTipoClienteSeleccionado] = useState(null);
    const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
    const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);

    // Dropdowns
    const [dropdownGrupoAbierto, setDropdownGrupoAbierto] = useState(false);
    const [dropdownPaisAbierto, setDropdownPaisAbierto] = useState(false);
    const [dropdownCiudadAbierto, setDropdownCiudadAbierto] = useState(false);
    const [dropdownZonaAbierto, setDropdownZonaAbierto] = useState(false);
    const [dropdownZonaVendedorAbierto, setDropdownZonaVendedorAbierto] = useState(false);
    const [dropdownVendedorAbierto, setDropdownVendedorAbierto] = useState(false);
    const [dropdownListaPrecioAbierto, setDropdownListaPrecioAbierto] = useState(false);
    const [dropdownFormaPagoAbierto, setDropdownFormaPagoAbierto] = useState(false);
    const [dropdownCadenaAbierto, setDropdownCadenaAbierto] = useState(false);
    const [dropdownCanalAbierto, setDropdownCanalAbierto] = useState(false);
    const [dropdownTipoClienteAbierto, setDropdownTipoClienteAbierto] = useState(false);
    const [dropdownCuentaAbierto, setDropdownCuentaAbierto] = useState(false);
    const [dropdownSucursalAbierto, setDropdownSucursalAbierto] = useState(false);

    // Búsquedas
    const [busquedaGrupo, setBusquedaGrupo] = useState('');
    const [busquedaPais, setBusquedaPais] = useState('');
    const [busquedaCiudad, setBusquedaCiudad] = useState('');
    const [busquedaZona, setBusquedaZona] = useState('');
    const [busquedaZonaVendedor, setBusquedaZonaVendedor] = useState('');
    const [busquedaVendedor, setBusquedaVendedor] = useState('');
    const [busquedaListaPrecio, setBusquedaListaPrecio] = useState('');
    const [busquedaFormaPago, setBusquedaFormaPago] = useState('');
    const [busquedaCadena, setBusquedaCadena] = useState('');
    const [busquedaCanal, setBusquedaCanal] = useState('');
    const [busquedaTipoCliente, setBusquedaTipoCliente] = useState('');
    const [busquedaCuenta, setBusquedaCuenta] = useState('');
    const [busquedaSucursal, setBusquedaSucursal] = useState('');

    // Refs
    const dropdownGrupoRef = useRef(null);
    const dropdownPaisRef = useRef(null);
    const dropdownCiudadRef = useRef(null);
    const dropdownZonaRef = useRef(null);
    const dropdownZonaVendedorRef = useRef(null);
    const dropdownVendedorRef = useRef(null);
    const dropdownListaPrecioRef = useRef(null);
    const dropdownFormaPagoRef = useRef(null);
    const dropdownCadenaRef = useRef(null);
    const dropdownCanalRef = useRef(null);
    const dropdownTipoClienteRef = useRef(null);
    const dropdownCuentaRef = useRef(null);
    const dropdownSucursalRef = useRef(null);

    const [formulario, setFormulario] = useState({
        idCliente: '',
        idGrupocli: 1,
        nomCliente: '',
        rucCliente: '',
        direccion: '',
        barrio: '',
        idPais: '',
        idCiudad: '',
        telefono: '',
        mail: '',
        agenteRet: 0,
        tipoCli: 1,
        zona: '',
        idZonav: '',
        idVendedor: '',
        idLisprecio: '',
        idFormapago: '',
        calificacion: '',
        idCadena: '',
        gln: '',
        vendVar: 0,
        exenta: 'N',
        idCanalcli: '',
        idClacli: '',
        cuenta: '',
        idSucursal: '',
        obs: '',
        idOperador: usuario || ''
    });

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    // Selector de columnas
    const [selectorColumnasAbierto, setSelectorColumnasAbierto] = useState(false);
    const selectorRef = useRef(null);

    const API_URL = '/api/clientes';

    // Definición completa de todas las columnas disponibles
    const todasLasColumnas = [
        { key: 'idCliente', label: 'ID', visible: true, fixed: true },
        { key: 'nomCliente', label: 'Nombre', visible: true, fixed: true },
        { key: 'rucCliente', label: 'RUC', visible: true },
        { key: 'direccion', label: 'Dirección', visible: true },
        { key: 'telefono', label: 'Teléfono', visible: true },
        { key: 'mail', label: 'Email', visible: true },
        { key: 'barrio', label: 'Barrio', visible: false },
        { key: 'idGrupocli', label: 'Grupo Cliente', visible: false },
        { key: 'idPais', label: 'País', visible: false },
        { key: 'idCiudad', label: 'Ciudad', visible: false },
        { key: 'agenteRet', label: 'Agente Retención', visible: false },
        { key: 'tipoCli', label: 'Tipo Cliente', visible: false },
        { key: 'zona', label: 'Zona', visible: false },
        { key: 'idZonav', label: 'Zona Vendedor', visible: false },
        { key: 'idVendedor', label: 'Vendedor', visible: false },
        { key: 'idLisprecio', label: 'Lista Precio', visible: false },
        { key: 'idFormapago', label: 'Forma Pago', visible: false },
        { key: 'calificacion', label: 'Calificación', visible: false },
        { key: 'idCadena', label: 'Cadena', visible: false },
        { key: 'gln', label: 'GLN', visible: false },
        { key: 'vendVar', label: 'Vend Var', visible: false },
        { key: 'exenta', label: 'Exenta', visible: false },
        { key: 'idCanalcli', label: 'Canal', visible: false },
        { key: 'idClacli', label: 'Clasificación', visible: false },
        { key: 'cuenta', label: 'Cuenta', visible: false },
        { key: 'idSucursal', label: 'Sucursal', visible: false },
        { key: 'obs', label: 'Observaciones', visible: false },
        { key: 'acciones', label: 'Acciones', visible: true, fixed: true }
    ];

    const [columnasVisibles, setColumnasVisibles] = useState(() => {
        const guardadas = localStorage.getItem('columnasClientes');
        if (guardadas) {
            return JSON.parse(guardadas);
        }
        return todasLasColumnas;
    });

    useEffect(() => {
        cargarClientes();
        cargarDatosSelectores();
    }, []);

    useEffect(() => {
        filtrarClientes();
    }, [busqueda, clientes]);

    // Filtrar ciudades cuando cambia el país
    useEffect(() => {
        if (paisSeleccionado) {
            const ciudadesPais = ciudades.filter(c => c.idPais === paisSeleccionado.idPais);
            setCiudadesFiltradas(ciudadesPais);
        } else {
            setCiudadesFiltradas([]);
        }
    }, [paisSeleccionado, ciudades]);

    // Cerrar dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownGrupoRef.current && !dropdownGrupoRef.current.contains(event.target)) {
                setDropdownGrupoAbierto(false);
            }
            if (dropdownPaisRef.current && !dropdownPaisRef.current.contains(event.target)) {
                setDropdownPaisAbierto(false);
            }
            if (dropdownCiudadRef.current && !dropdownCiudadRef.current.contains(event.target)) {
                setDropdownCiudadAbierto(false);
            }
            if (dropdownZonaRef.current && !dropdownZonaRef.current.contains(event.target)) {
                setDropdownZonaAbierto(false);
            }
            if (dropdownZonaVendedorRef.current && !dropdownZonaVendedorRef.current.contains(event.target)) {
                setDropdownZonaVendedorAbierto(false);
            }
            if (dropdownVendedorRef.current && !dropdownVendedorRef.current.contains(event.target)) {
                setDropdownVendedorAbierto(false);
            }
            if (dropdownListaPrecioRef.current && !dropdownListaPrecioRef.current.contains(event.target)) {
                setDropdownListaPrecioAbierto(false);
            }
            if (dropdownFormaPagoRef.current && !dropdownFormaPagoRef.current.contains(event.target)) {
                setDropdownFormaPagoAbierto(false);
            }
            if (dropdownCadenaRef.current && !dropdownCadenaRef.current.contains(event.target)) {
                setDropdownCadenaAbierto(false);
            }
            if (dropdownCanalRef.current && !dropdownCanalRef.current.contains(event.target)) {
                setDropdownCanalAbierto(false);
            }
            if (dropdownTipoClienteRef.current && !dropdownTipoClienteRef.current.contains(event.target)) {
                setDropdownTipoClienteAbierto(false);
            }
            if (dropdownCuentaRef.current && !dropdownCuentaRef.current.contains(event.target)) {
                setDropdownCuentaAbierto(false);
            }
            if (dropdownSucursalRef.current && !dropdownSucursalRef.current.contains(event.target)) {
                setDropdownSucursalAbierto(false);
            }
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setSelectorColumnasAbierto(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Guardar configuración de columnas en localStorage
    useEffect(() => {
        localStorage.setItem('columnasClientes', JSON.stringify(columnasVisibles));
    }, [columnasVisibles]);

    const cargarDatosSelectores = async () => {
        try {
            // Cargar grupos de cliente
            const respGrupos = await axios.get('/api/gruposcli');
            setGruposCliente(respGrupos.data);

            // Cargar países
            const respPaises = await axios.get('/api/paises');
            setPaises(respPaises.data);

            // Cargar ciudades
            const respCiudades = await axios.get('/api/ciudades');
            setCiudades(respCiudades.data);

            // Cargar zonas
            const respZonas = await axios.get('/api/zonas');
            setZonas(respZonas.data);

            // Cargar zonas de vendedor
            const respZonasVendedor = await axios.get('/api/zonas-vendedor');
            setZonasVendedor(respZonasVendedor.data);

            // Cargar vendedores
            const respVendedores = await axios.get('/api/vendedores');
            setVendedores(respVendedores.data);

            // Cargar listas de precio
            const respListasPrecio = await axios.get('/api/listas-precio');
            setListasPrecio(respListasPrecio.data);

            // Cargar formas de pago
            const respFormasPago = await axios.get('/api/fpago');
            setFormasPago(respFormasPago.data);

            // Cargar cadenas
            const respCadenas = await axios.get('/api/cadenas');
            setCadenas(respCadenas.data);

            // Cargar canales
            const respCanales = await axios.get('/api/canalescliente');
            setCanales(respCanales.data);

            // Cargar tipos de cliente
            const respTiposCliente = await axios.get('/api/tiposcliente');
            setTiposCliente(respTiposCliente.data);

            // Cargar cuentas imputables
            const respCuentas = await axios.get('/api/cuentas/imputables');
            setCuentas(respCuentas.data);

            // Cargar sucursales
            const respSucursales = await axios.get('/api/sucursales');
            setSucursales(respSucursales.data);

        } catch (error) {
            console.error('Error al cargar datos de selectores:', error);
        }
    };

    const cargarClientes = async () => {
        try {
            const response = await axios.get(API_URL);
            setClientes(response.data);
            setClientesFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar clientes:', error);
            alert('Error al cargar los clientes');
        }
    };

    const filtrarClientes = () => {
        if (!busqueda) {
            setClientesFiltrados(clientes);
            setPaginaActual(1);
            return;
        }

        const filtrados = clientes.filter(cliente =>
            cliente.idCliente?.toString().includes(busqueda) ||
            cliente.nomCliente?.toLowerCase().includes(busqueda.toLowerCase()) ||
            cliente.rucCliente?.includes(busqueda)
        );
        setClientesFiltrados(filtrados);
        setPaginaActual(1);
    };

    // Funciones de validación
    const validarEmail = (email) => {
        if (!email) return true; // Email es opcional
        const emails = email.split(',').map(e => e.trim());
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emails.every(e => emailRegex.test(e));
    };

    // Funciones para selectores
    const filtrarGrupos = (busq) => {
        if (!busq) return gruposCliente;
        return gruposCliente.filter(g =>
            g.idGrupocli?.toString().includes(busq) ||
            g.nomGrupocli?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarGrupo = (grupo) => {
        setGrupoClienteSeleccionado(grupo);
        setFormulario({ ...formulario, idGrupocli: grupo.idGrupocli });
        setBusquedaGrupo('');
        setDropdownGrupoAbierto(false);
    };

    const filtrarPaises = (busq) => {
        if (!busq) return paises;
        return paises.filter(p =>
            p.idPais?.toLowerCase().includes(busq.toLowerCase()) ||
            p.nomPais?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarPais = (pais) => {
        setPaisSeleccionado(pais);
        setFormulario({ ...formulario, idPais: pais.idPais, idCiudad: '' });
        setCiudadSeleccionada(null);
        setBusquedaPais('');
        setDropdownPaisAbierto(false);
    };

    const filtrarCiudades = (busq) => {
        if (!busq) return ciudadesFiltradas.slice(0, 100);
        return ciudadesFiltradas.filter(c =>
            c.idCiudad?.toString().includes(busq) ||
            c.nomCiudad?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarCiudad = (ciudad) => {
        setCiudadSeleccionada(ciudad);
        setFormulario({ ...formulario, idCiudad: ciudad.idCiudad });
        setBusquedaCiudad('');
        setDropdownCiudadAbierto(false);
    };

    const filtrarZonas = (busq) => {
        if (!busq) return zonas;
        return zonas.filter(z =>
            z.idZona?.toString().includes(busq) ||
            z.nomZona?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarZona = (zona) => {
        setZonaSeleccionada(zona);
        setFormulario({ ...formulario, zona: zona.idZona });
        setBusquedaZona('');
        setDropdownZonaAbierto(false);
    };

    const filtrarZonasVendedor = (busq) => {
        if (!busq) return zonasVendedor;
        return zonasVendedor.filter(zv =>
            zv.idZonav?.toString().includes(busq) ||
            zv.nomZonav?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarZonaVendedor = (zonaVendedor) => {
        setZonaVendedorSeleccionada(zonaVendedor);
        setFormulario({ ...formulario, idZonav: zonaVendedor.idZonav });
        setBusquedaZonaVendedor('');
        setDropdownZonaVendedorAbierto(false);
    };

    const filtrarVendedores = (busq) => {
        if (!busq) return vendedores.slice(0, 100);
        return vendedores.filter(v =>
            v.idVendedor?.toString().includes(busq) ||
            v.nomVendedor?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarVendedor = (vendedor) => {
        setVendedorSeleccionado(vendedor);
        setFormulario({ ...formulario, idVendedor: vendedor.idVendedor });
        setBusquedaVendedor('');
        setDropdownVendedorAbierto(false);
    };

    const filtrarListasPrecio = (busq) => {
        if (!busq) return listasPrecio.slice(0, 100);
        return listasPrecio.filter(lp =>
            lp.idLisprecio?.toString().includes(busq) ||
            lp.obs?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarListaPrecio = (listaPrecio) => {
        setListaPrecioSeleccionada(listaPrecio);
        setFormulario({ ...formulario, idLisprecio: listaPrecio.idLisprecio });
        setBusquedaListaPrecio('');
        setDropdownListaPrecioAbierto(false);
    };

    const filtrarFormasPago = (busq) => {
        if (!busq) return formasPago;
        return formasPago.filter(fp =>
            fp.idFpago?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarFormaPago = (formaPago) => {
        setFormaPagoSeleccionada(formaPago);
        setFormulario({ ...formulario, idFormapago: formaPago.idFpago });
        setBusquedaFormaPago('');
        setDropdownFormaPagoAbierto(false);
    };

    const filtrarCadenas = (busq) => {
        if (!busq) return cadenas.slice(0, 100);
        return cadenas.filter(c =>
            c.idCadena?.toString().includes(busq) ||
            c.nomCadena?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarCadena = (cadena) => {
        setCadenaSeleccionada(cadena);
        setFormulario({ ...formulario, idCadena: cadena.idCadena });
        setBusquedaCadena('');
        setDropdownCadenaAbierto(false);
    };

    const filtrarCanales = (busq) => {
        if (!busq) return canales;
        return canales.filter(c =>
            c.idCanal?.toString().includes(busq) ||
            c.nomCanal?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarCanal = (canal) => {
        setCanalSeleccionado(canal);
        setFormulario({ ...formulario, idCanalcli: canal.idCanal });
        setBusquedaCanal('');
        setDropdownCanalAbierto(false);
    };

    const filtrarTiposCliente = (busq) => {
        if (!busq) return tiposCliente;
        return tiposCliente.filter(tc =>
            tc.idClacli?.toString().includes(busq) ||
            tc.nomClacli?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarTipoCliente = (tipoCliente) => {
        setTipoClienteSeleccionado(tipoCliente);
        setFormulario({ ...formulario, idClacli: tipoCliente.idClacli });
        setBusquedaTipoCliente('');
        setDropdownTipoClienteAbierto(false);
    };

    const filtrarCuentas = (busq) => {
        if (!busq) return cuentas.slice(0, 100);
        return cuentas.filter(c =>
            c.cuenta?.includes(busq) ||
            c.descripcion?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarCuenta = (cuenta) => {
        setCuentaSeleccionada(cuenta);
        setFormulario({ ...formulario, cuenta: cuenta.cuenta });
        setBusquedaCuenta('');
        setDropdownCuentaAbierto(false);
    };

    const filtrarSucursales = (busq) => {
        if (!busq) return sucursales;
        return sucursales.filter(s =>
            s.idSucursal?.toString().includes(busq) ||
            s.nombre?.toLowerCase().includes(busq.toLowerCase())
        );
    };

    const seleccionarSucursal = (sucursal) => {
        setSucursalSeleccionada(sucursal);
        setFormulario({ ...formulario, idSucursal: sucursal.idSucursal });
        setBusquedaSucursal('');
        setDropdownSucursalAbierto(false);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idCliente: '',
            idGrupocli: 1,
            nomCliente: '',
            rucCliente: '',
            direccion: '',
            barrio: '',
            idPais: '',
            idCiudad: '',
            telefono: '',
            mail: '',
            agenteRet: 0,
            tipoCli: 1,
            zona: '',
            idZonav: '',
            idVendedor: '',
            idLisprecio: '',
            idFormapago: '',
            calificacion: '',
            idCadena: '',
            gln: '',
            vendVar: 0,
            exenta: 'N',
            idCanalcli: '',
            idClacli: '',
            cuenta: '',
            idSucursal: '',
            obs: '',
            idOperador: usuario || ''
        });

        // Limpiar selectores
        setGrupoClienteSeleccionado(null);
        setPaisSeleccionado(null);
        setCiudadSeleccionada(null);
        setZonaSeleccionada(null);
        setZonaVendedorSeleccionada(null);
        setVendedorSeleccionado(null);
        setListaPrecioSeleccionada(null);
        setFormaPagoSeleccionada(null);
        setCadenaSeleccionada(null);
        setCanalSeleccionado(null);
        setTipoClienteSeleccionado(null);
        setCuentaSeleccionada(null);
        setSucursalSeleccionada(null);

        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (cliente) => {
        setFormulario({
            idCliente: cliente.idCliente,
            idGrupocli: cliente.idGrupocli || 1,
            nomCliente: cliente.nomCliente || '',
            rucCliente: cliente.rucCliente || '',
            direccion: cliente.direccion || '',
            barrio: cliente.barrio || '',
            idPais: cliente.idPais || '',
            idCiudad: cliente.idCiudad || '',
            telefono: cliente.telefono || '',
            mail: cliente.mail || '',
            agenteRet: cliente.agenteRet || 0,
            tipoCli: cliente.tipoCli || 1,
            zona: cliente.zona || '',
            idZonav: cliente.idZonav || '',
            idVendedor: cliente.idVendedor || '',
            idLisprecio: cliente.idLisprecio || '',
            idFormapago: cliente.idFormapago || '',
            calificacion: cliente.calificacion || '',
            idCadena: cliente.idCadena || '',
            gln: cliente.gln || '',
            vendVar: cliente.vendVar || 0,
            exenta: cliente.exenta || 'N',
            idCanalcli: cliente.idCanalcli || '',
            idClacli: cliente.idClacli || '',
            cuenta: cliente.cuenta || '',
            idSucursal: cliente.idSucursal || '',
            obs: cliente.obs || '',
            idOperador: cliente.idOperador || usuario || ''
        });

        // Buscar y establecer los objetos seleccionados
        if (cliente.idGrupocli) {
            const grupo = gruposCliente.find(g => g.idGrupocli === cliente.idGrupocli);
            setGrupoClienteSeleccionado(grupo || null);
        } else {
            setGrupoClienteSeleccionado(null);
        }

        if (cliente.idPais) {
            const pais = paises.find(p => p.idPais === cliente.idPais);
            setPaisSeleccionado(pais || null);
        } else {
            setPaisSeleccionado(null);
        }

        if (cliente.idCiudad && cliente.idPais) {
            const ciudad = ciudades.find(c => c.idPais === cliente.idPais && c.idCiudad === cliente.idCiudad);
            setCiudadSeleccionada(ciudad || null);
        } else {
            setCiudadSeleccionada(null);
        }

        if (cliente.zona) {
            const zona = zonas.find(z => z.idZona === cliente.zona);
            setZonaSeleccionada(zona || null);
        } else {
            setZonaSeleccionada(null);
        }

        if (cliente.idZonav) {
            const zonaVendedor = zonasVendedor.find(zv => zv.idZonav === cliente.idZonav);
            setZonaVendedorSeleccionada(zonaVendedor || null);
        } else {
            setZonaVendedorSeleccionada(null);
        }

        if (cliente.idVendedor) {
            const vendedor = vendedores.find(v => v.idVendedor === cliente.idVendedor);
            setVendedorSeleccionado(vendedor || null);
        } else {
            setVendedorSeleccionado(null);
        }

        if (cliente.idLisprecio) {
            const listaPrecio = listasPrecio.find(lp => lp.idLisprecio === cliente.idLisprecio);
            setListaPrecioSeleccionada(listaPrecio || null);
        } else {
            setListaPrecioSeleccionada(null);
        }

        if (cliente.idFormapago) {
            const formaPago = formasPago.find(fp => fp.idFpago === cliente.idFormapago);
            setFormaPagoSeleccionada(formaPago || null);
        } else {
            setFormaPagoSeleccionada(null);
        }

        if (cliente.idCadena) {
            const cadena = cadenas.find(c => c.idCadena === cliente.idCadena);
            setCadenaSeleccionada(cadena || null);
        } else {
            setCadenaSeleccionada(null);
        }

        if (cliente.idCanalcli) {
            const canal = canales.find(c => c.idCanal === cliente.idCanalcli);
            setCanalSeleccionado(canal || null);
        } else {
            setCanalSeleccionado(null);
        }

        if (cliente.idClacli) {
            const tipoCliente = tiposCliente.find(tc => tc.idClacli === cliente.idClacli);
            setTipoClienteSeleccionado(tipoCliente || null);
        } else {
            setTipoClienteSeleccionado(null);
        }

        if (cliente.cuenta) {
            const cuenta = cuentas.find(c => c.cuenta === cliente.cuenta);
            setCuentaSeleccionada(cuenta || null);
        } else {
            setCuentaSeleccionada(null);
        }

        if (cliente.idSucursal) {
            const sucursal = sucursales.find(s => s.idSucursal === cliente.idSucursal);
            setSucursalSeleccionada(sucursal || null);
        } else {
            setSucursalSeleccionada(null);
        }

        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validaciones
        if (!formulario.nomCliente.trim() || !formulario.rucCliente.trim() || !formulario.direccion.trim()) {
            alert('Nombre, RUC y Dirección son obligatorios');
            return;
        }

        if (!formulario.idSucursal) {
            alert('La sucursal es obligatoria');
            return;
        }

        if (formulario.mail && !validarEmail(formulario.mail)) {
            alert('El formato del email no es válido. Use comas para separar múltiples emails.');
            return;
        }

        try {
            const clienteData = {
                ...formulario,
                idOperador: usuario || formulario.idOperador
            };

            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idCliente}`, clienteData);
                alert('Cliente actualizado exitosamente');
            } else {
                await axios.post(API_URL, clienteData);
                alert('Cliente creado exitosamente');
            }
            cargarClientes();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el cliente');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este cliente?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('Cliente eliminado exitosamente');
                cargarClientes();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el cliente');
            }
        }
    };

    const toggleColumna = (key) => {
        setColumnasVisibles(prev =>
            prev.map(col =>
                col.key === key && !col.fixed
                    ? { ...col, visible: !col.visible }
                    : col
            )
        );
    };

    const mostrarTodasColumnas = () => {
        setColumnasVisibles(prev => prev.map(col => ({ ...col, visible: true })));
    };

    const ocultarTodasColumnas = () => {
        setColumnasVisibles(prev =>
            prev.map(col =>
                col.fixed
                    ? col
                    : { ...col, visible: false }
            )
        );
    };

    const restaurarColumnasDefecto = () => {
        setColumnasVisibles(todasLasColumnas);
        localStorage.removeItem('columnasClientes');
    };

    const formatearValor = (valor, key) => {
        if (valor === null || valor === undefined) return '';

        switch (key) {
            case 'agenteRet':
                return valor === 1 ? 'Sí' : 'No';
            case 'vendVar':
                return valor === 1 ? 'Sí' : 'No';
            case 'exenta':
                return valor === 'S' ? 'Sí' : 'No';
            default:
                return valor;
        }
    };

    const exportarExcel = () => {
        const columnasParaExportar = columnasVisibles.filter(col => col.visible && col.key !== 'acciones');

        const datosExportar = clientesFiltrados.map(cliente => {
            const fila = {};
            columnasParaExportar.forEach(col => {
                fila[col.label] = formatearValor(cliente[col.key], col.key);
            });
            return fila;
        });

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Clientes');
        XLSX.writeFile(workbook, 'clientes.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const clientesActuales = clientesFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(clientesFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    // Renderizar selector genérico
    const renderSelector = (label, seleccionado, dropdown, busqueda, setBusqueda, setDropdown, filtrar, seleccionar, limpiar, ref, obligatorio = false, disabled = false, placeholder = "Buscar...") => (
        <div className="form-group">
            <label>{label} {obligatorio && '*'}</label>
            <div className="cuenta-selector" ref={ref}>
                {seleccionado ? (
                    <div className="cuenta-seleccionada">
                        <span>{seleccionado.displayText || `${seleccionado.id} - ${seleccionado.nombre}`}</span>
                        <button type="button" onClick={limpiar} className="btn-limpiar">✕</button>
                    </div>
                ) : (
                    <input
                        type="text"
                        placeholder={placeholder}
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        onFocus={() => !disabled && setDropdown(true)}
                        className="input-busqueda"
                        disabled={disabled}
                    />
                )}

                {dropdown && !seleccionado && !disabled && (
                    <div className="cuenta-dropdown">
                        {filtrar(busqueda).map((item, index) => (
                            <div
                                key={item.key || index}
                                className="cuenta-item"
                                onClick={() => seleccionar(item)}
                            >
                                {item.displayText || `${item.id} - ${item.nombre}`}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Clientes</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <div className="selector-columnas-wrapper" ref={selectorRef}>
                        <button
                            onClick={() => setSelectorColumnasAbierto(!selectorColumnasAbierto)}
                            className="btn btn-columnas"
                            title="Configurar columnas"
                        >
                            ⚙️ Columnas
                        </button>

                        {selectorColumnasAbierto && (
                            <div className="selector-columnas-dropdown">
                                <div className="selector-columnas-header">
                                    <h4>Configurar Columnas</h4>
                                    <button
                                        onClick={() => setSelectorColumnasAbierto(false)}
                                        className="btn-cerrar-selector"
                                    >
                                        ✖
                                    </button>
                                </div>

                                <div className="selector-columnas-acciones">
                                    <button onClick={mostrarTodasColumnas} className="btn-selector-mini">
                                        ✓ Todas
                                    </button>
                                    <button onClick={ocultarTodasColumnas} className="btn-selector-mini">
                                        ✗ Ninguna
                                    </button>
                                    <button onClick={restaurarColumnasDefecto} className="btn-selector-mini">
                                        ↺ Restaurar
                                    </button>
                                </div>

                                <div className="selector-columnas-lista">
                                    {columnasVisibles.map(columna => (
                                        <label
                                            key={columna.key}
                                            className={`selector-columna-item ${columna.fixed ? 'fija' : ''}`}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={columna.visible}
                                                onChange={() => toggleColumna(columna.key)}
                                                disabled={columna.fixed}
                                            />
                                            <span>{columna.label}</span>
                                            {columna.fixed && <span className="badge-fija">Fija</span>}
                                        </label>
                                    ))}
                                </div>

                                <div className="selector-columnas-footer">
                                    <small>
                                        {columnasVisibles.filter(c => c.visible).length} de {columnasVisibles.length} columnas visibles
                                    </small>
                                </div>
                            </div>
                        )}
                    </div>
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Cliente
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            {columnasVisibles.filter(col => col.visible).map(columna => (
                                <th key={columna.key}>
                                    {columna.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {clientesActuales.length === 0 ? (
                            <tr>
                                <td colSpan={columnasVisibles.filter(col => col.visible).length} className="sin-datos">
                                    No hay clientes para mostrar
                                </td>
                            </tr>
                        ) : (
                            clientesActuales.map(cliente => (
                                <tr key={cliente.idCliente}>
                                    {columnasVisibles.filter(col => col.visible).map(columna => {
                                        if (columna.key === 'acciones') {
                                            return (
                                                <td key={columna.key}>
                                                    <button
                                                        onClick={() => abrirModalEditar(cliente)}
                                                        className="btn-accion"
                                                        title="Editar"
                                                    >
                                                        ✏️
                                                    </button>
                                                    <button
                                                        onClick={() => eliminar(cliente.idCliente)}
                                                        className="btn-accion"
                                                        title="Eliminar"
                                                    >
                                                        🗑️
                                                    </button>
                                                </td>
                                            );
                                        }

                                        return (
                                            <td key={columna.key}>
                                                {formatearValor(cliente[columna.key], columna.key)}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Paginación - código similar a otros CRUDs */}
            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, clientesFiltrados.length)} de {clientesFiltrados.length} registros
                    </span>
                    <select value={itemsPorPagina} onChange={cambiarItemsPorPagina} className="select-registros">
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button onClick={() => cambiarPagina(1)} disabled={paginaActual === 1} className="btn-paginacion">⏮️</button>
                    <button onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1} className="btn-paginacion">◀️</button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (numeroPagina === 1 || numeroPagina === totalPaginas || (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)) {
                            return (
                                <button key={numeroPagina} onClick={() => cambiarPagina(numeroPagina)} className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}>
                                    {numeroPagina}
                                </button>
                            );
                        } else if (numeroPagina === paginaActual - 2 || numeroPagina === paginaActual + 2) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas} className="btn-paginacion">▶️</button>
                    <button onClick={() => cambiarPagina(totalPaginas)} disabled={paginaActual === totalPaginas} className="btn-paginacion">⏭️</button>
                </div>
            </div>

            {/* Modal con formulario completo */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido" style={{ maxWidth: '1000px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Cliente' : 'Nuevo Cliente'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                                {/* Columna 1 */}
                                <div>
                                    {/* Grupo de Cliente */}
                                    <div className="form-group">
                                        <label>Grupo de Cliente *</label>
                                        <div className="cuenta-selector" ref={dropdownGrupoRef}>
                                            {grupoClienteSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{grupoClienteSeleccionado.idGrupocli} - {grupoClienteSeleccionado.nomGrupocli}</span>
                                                    <button type="button" onClick={() => { setGrupoClienteSeleccionado(null); setFormulario({...formulario, idGrupocli: 1}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar grupo..." value={busquedaGrupo} onChange={(e) => setBusquedaGrupo(e.target.value)} onFocus={() => setDropdownGrupoAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownGrupoAbierto && !grupoClienteSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarGrupos(busquedaGrupo).map(grupo => (
                                                        <div key={grupo.idGrupocli} className="cuenta-item" onClick={() => seleccionarGrupo(grupo)}>
                                                            <strong>{grupo.idGrupocli}</strong> - {grupo.nomGrupocli}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Nombre */}
                                    <div className="form-group">
                                        <label>Nombre del Cliente *</label>
                                        <input type="text" value={formulario.nomCliente} onChange={(e) => setFormulario({...formulario, nomCliente: e.target.value})} required maxLength={100} placeholder="Nombre del cliente" />
                                    </div>

                                    {/* RUC */}
                                    <div className="form-group">
                                        <label>RUC *</label>
                                        <input type="text" value={formulario.rucCliente} onChange={(e) => setFormulario({...formulario, rucCliente: e.target.value})} required maxLength={12} placeholder="RUC" />
                                    </div>

                                    {/* Dirección */}
                                    <div className="form-group">
                                        <label>Dirección *</label>
                                        <input type="text" value={formulario.direccion} onChange={(e) => setFormulario({...formulario, direccion: e.target.value})} required maxLength={60} placeholder="Dirección" />
                                    </div>

                                    {/* Barrio */}
                                    <div className="form-group">
                                        <label>Barrio</label>
                                        <input type="text" value={formulario.barrio} onChange={(e) => setFormulario({...formulario, barrio: e.target.value})} maxLength={20} placeholder="Barrio" />
                                    </div>

                                    {/* País */}
                                    <div className="form-group">
                                        <label>País</label>
                                        <div className="cuenta-selector" ref={dropdownPaisRef}>
                                            {paisSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{paisSeleccionado.idPais} - {paisSeleccionado.nomPais}</span>
                                                    <button type="button" onClick={() => { setPaisSeleccionado(null); setCiudadSeleccionada(null); setFormulario({...formulario, idPais: '', idCiudad: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar país..." value={busquedaPais} onChange={(e) => setBusquedaPais(e.target.value)} onFocus={() => setDropdownPaisAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownPaisAbierto && !paisSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarPaises(busquedaPais).map(pais => (
                                                        <div key={pais.idPais} className="cuenta-item" onClick={() => seleccionarPais(pais)}>
                                                            <strong>{pais.idPais}</strong> - {pais.nomPais}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Ciudad */}
                                    <div className="form-group">
                                        <label>Ciudad</label>
                                        <div className="cuenta-selector" ref={dropdownCiudadRef}>
                                            {ciudadSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{ciudadSeleccionada.idCiudad} - {ciudadSeleccionada.nomCiudad}</span>
                                                    <button type="button" onClick={() => { setCiudadSeleccionada(null); setFormulario({...formulario, idCiudad: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder={paisSeleccionado ? "Buscar ciudad..." : "Primero seleccione un país"} value={busquedaCiudad} onChange={(e) => setBusquedaCiudad(e.target.value)} onFocus={() => paisSeleccionado && setDropdownCiudadAbierto(true)} className="input-busqueda" disabled={!paisSeleccionado} />
                                            )}
                                            {dropdownCiudadAbierto && !ciudadSeleccionada && paisSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarCiudades(busquedaCiudad).map(ciudad => (
                                                        <div key={`${ciudad.idPais}-${ciudad.idCiudad}`} className="cuenta-item" onClick={() => seleccionarCiudad(ciudad)}>
                                                            <strong>{ciudad.idCiudad}</strong> - {ciudad.nomCiudad}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Teléfono */}
                                    <div className="form-group">
                                        <label>Teléfono</label>
                                        <input type="text" value={formulario.telefono} onChange={(e) => setFormulario({...formulario, telefono: e.target.value})} maxLength={30} placeholder="Teléfono" />
                                    </div>

                                    {/* Email */}
                                    <div className="form-group">
                                        <label>Email (separar con comas)</label>
                                        <input type="text" value={formulario.mail} onChange={(e) => setFormulario({...formulario, mail: e.target.value})} maxLength={50} placeholder="email@ejemplo.com, otro@ejemplo.com" />
                                    </div>
                                </div>

                                {/* Columna 2 */}
                                <div>
                                    {/* Agente de Retención */}
                                    <div className="form-group">
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <input type="checkbox" checked={formulario.agenteRet === 1} onChange={(e) => setFormulario({...formulario, agenteRet: e.target.checked ? 1 : 0})} />
                                            Agente de Retención
                                        </label>
                                    </div>

                                    {/* Tipo de Cliente */}
                                    <div className="form-group">
                                        <label>Tipo de Cliente</label>
                                        <input type="number" value={formulario.tipoCli} onChange={(e) => setFormulario({...formulario, tipoCli: parseInt(e.target.value) || 1})} placeholder="1" />
                                    </div>

                                    {/* Lista de Precio */}
                                    <div className="form-group">
                                        <label>Lista de Precio</label>
                                        <div className="cuenta-selector" ref={dropdownListaPrecioRef}>
                                            {listaPrecioSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{listaPrecioSeleccionada.idLisprecio} - {listaPrecioSeleccionada.obs || 'Sin descripción'}</span>
                                                    <button type="button" onClick={() => { setListaPrecioSeleccionada(null); setFormulario({...formulario, idLisprecio: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar lista de precio..." value={busquedaListaPrecio} onChange={(e) => setBusquedaListaPrecio(e.target.value)} onFocus={() => setDropdownListaPrecioAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownListaPrecioAbierto && !listaPrecioSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarListasPrecio(busquedaListaPrecio).map(lp => (
                                                        <div key={lp.idLisprecio} className="cuenta-item" onClick={() => seleccionarListaPrecio(lp)}>
                                                            <strong>{lp.idLisprecio}</strong> - {lp.obs || 'Sin descripción'}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Forma de Pago */}
                                    <div className="form-group">
                                        <label>Forma de Pago</label>
                                        <div className="cuenta-selector" ref={dropdownFormaPagoRef}>
                                            {formaPagoSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{formaPagoSeleccionada.idFpago}</span>
                                                    <button type="button" onClick={() => { setFormaPagoSeleccionada(null); setFormulario({...formulario, idFormapago: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar forma de pago..." value={busquedaFormaPago} onChange={(e) => setBusquedaFormaPago(e.target.value)} onFocus={() => setDropdownFormaPagoAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownFormaPagoAbierto && !formaPagoSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarFormasPago(busquedaFormaPago).map(fp => (
                                                        <div key={fp.idFpago} className="cuenta-item" onClick={() => seleccionarFormaPago(fp)}>
                                                            <strong>{fp.idFpago}</strong>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Calificación */}
                                    <div className="form-group">
                                        <label>Calificación</label>
                                        <input type="number" value={formulario.calificacion} onChange={(e) => setFormulario({...formulario, calificacion: parseInt(e.target.value) || ''})} placeholder="Calificación" />
                                    </div>

                                    {/* GLN */}
                                    <div className="form-group">
                                        <label>GLN</label>
                                        <input type="text" value={formulario.gln} onChange={(e) => setFormulario({...formulario, gln: e.target.value})} maxLength={50} placeholder="GLN" />
                                    </div>

                                    {/* Vend Var */}
                                    <div className="form-group">
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <input type="checkbox" checked={formulario.vendVar === 1} onChange={(e) => setFormulario({...formulario, vendVar: e.target.checked ? 1 : 0})} />
                                            Vend Var
                                        </label>
                                    </div>

                                    {/* Exenta */}
                                    <div className="form-group">
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <input type="checkbox" checked={formulario.exenta === 'S'} onChange={(e) => setFormulario({...formulario, exenta: e.target.checked ? 'S' : 'N'})} />
                                            Exenta
                                        </label>
                                    </div>

                                    {/* Tipo de Cliente (Clasificación) */}
                                    <div className="form-group">
                                        <label>Clasificación de Cliente</label>
                                        <div className="cuenta-selector" ref={dropdownTipoClienteRef}>
                                            {tipoClienteSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{tipoClienteSeleccionado.idClacli} - {tipoClienteSeleccionado.nomClacli}</span>
                                                    <button type="button" onClick={() => { setTipoClienteSeleccionado(null); setFormulario({...formulario, idClacli: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar clasificación..." value={busquedaTipoCliente} onChange={(e) => setBusquedaTipoCliente(e.target.value)} onFocus={() => setDropdownTipoClienteAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownTipoClienteAbierto && !tipoClienteSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarTiposCliente(busquedaTipoCliente).map(tc => (
                                                        <div key={tc.idClacli} className="cuenta-item" onClick={() => seleccionarTipoCliente(tc)}>
                                                            <strong>{tc.idClacli}</strong> - {tc.nomClacli}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Cuenta */}
                                    <div className="form-group">
                                        <label>Cuenta Imputable</label>
                                        <div className="cuenta-selector" ref={dropdownCuentaRef}>
                                            {cuentaSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{cuentaSeleccionada.cuenta} - {cuentaSeleccionada.descripcion}</span>
                                                    <button type="button" onClick={() => { setCuentaSeleccionada(null); setFormulario({...formulario, cuenta: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar cuenta..." value={busquedaCuenta} onChange={(e) => setBusquedaCuenta(e.target.value)} onFocus={() => setDropdownCuentaAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownCuentaAbierto && !cuentaSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarCuentas(busquedaCuenta).map(cuenta => (
                                                        <div key={cuenta.cuenta} className="cuenta-item" onClick={() => seleccionarCuenta(cuenta)}>
                                                            <strong>{cuenta.cuenta}</strong> - {cuenta.descripcion}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Sucursal */}
                                    <div className="form-group">
                                        <label>Sucursal *</label>
                                        <div className="cuenta-selector" ref={dropdownSucursalRef}>
                                            {sucursalSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{sucursalSeleccionada.idSucursal} - {sucursalSeleccionada.nombre}</span>
                                                    <button type="button" onClick={() => { setSucursalSeleccionada(null); setFormulario({...formulario, idSucursal: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar sucursal..." value={busquedaSucursal} onChange={(e) => setBusquedaSucursal(e.target.value)} onFocus={() => setDropdownSucursalAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownSucursalAbierto && !sucursalSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarSucursales(busquedaSucursal).map(sucursal => (
                                                        <div key={sucursal.idSucursal} className="cuenta-item" onClick={() => seleccionarSucursal(sucursal)}>
                                                            <strong>{sucursal.idSucursal}</strong> - {sucursal.nombre}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Columna 3 */}
                                <div>
                                    {/* Zona */}
                                    <div className="form-group">
                                        <label>Zona</label>
                                        <div className="cuenta-selector" ref={dropdownZonaRef}>
                                            {zonaSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{zonaSeleccionada.idZona} - {zonaSeleccionada.nomZona}</span>
                                                    <button type="button" onClick={() => { setZonaSeleccionada(null); setFormulario({...formulario, zona: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar zona..." value={busquedaZona} onChange={(e) => setBusquedaZona(e.target.value)} onFocus={() => setDropdownZonaAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownZonaAbierto && !zonaSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarZonas(busquedaZona).map(zona => (
                                                        <div key={zona.idZona} className="cuenta-item" onClick={() => seleccionarZona(zona)}>
                                                            <strong>{zona.idZona}</strong> - {zona.nomZona}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Vendedor */}
                                    <div className="form-group">
                                        <label>Vendedor</label>
                                        <div className="cuenta-selector" ref={dropdownVendedorRef}>
                                            {vendedorSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{vendedorSeleccionado.idVendedor} - {vendedorSeleccionado.nomVendedor}</span>
                                                    <button type="button" onClick={() => { setVendedorSeleccionado(null); setFormulario({...formulario, idVendedor: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar vendedor..." value={busquedaVendedor} onChange={(e) => setBusquedaVendedor(e.target.value)} onFocus={() => setDropdownVendedorAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownVendedorAbierto && !vendedorSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarVendedores(busquedaVendedor).map(vendedor => (
                                                        <div key={vendedor.idVendedor} className="cuenta-item" onClick={() => seleccionarVendedor(vendedor)}>
                                                            <strong>{vendedor.idVendedor}</strong> - {vendedor.nomVendedor}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Cadena */}
                                    <div className="form-group">
                                        <label>Cadena</label>
                                        <div className="cuenta-selector" ref={dropdownCadenaRef}>
                                            {cadenaSeleccionada ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{cadenaSeleccionada.idCadena} - {cadenaSeleccionada.nomCadena}</span>
                                                    <button type="button" onClick={() => { setCadenaSeleccionada(null); setFormulario({...formulario, idCadena: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar cadena..." value={busquedaCadena} onChange={(e) => setBusquedaCadena(e.target.value)} onFocus={() => setDropdownCadenaAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownCadenaAbierto && !cadenaSeleccionada && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarCadenas(busquedaCadena).map(cadena => (
                                                        <div key={cadena.idCadena} className="cuenta-item" onClick={() => seleccionarCadena(cadena)}>
                                                            <strong>{cadena.idCadena}</strong> - {cadena.nomCadena}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Canal */}
                                    <div className="form-group">
                                        <label>Canal</label>
                                        <div className="cuenta-selector" ref={dropdownCanalRef}>
                                            {canalSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{canalSeleccionado.idCanal} - {canalSeleccionado.nomCanal}</span>
                                                    <button type="button" onClick={() => { setCanalSeleccionado(null); setFormulario({...formulario, idCanalcli: ''}); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar canal..." value={busquedaCanal} onChange={(e) => setBusquedaCanal(e.target.value)} onFocus={() => setDropdownCanalAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownCanalAbierto && !canalSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarCanales(busquedaCanal).map(canal => (
                                                        <div key={canal.idCanal} className="cuenta-item" onClick={() => seleccionarCanal(canal)}>
                                                            <strong>{canal.idCanal}</strong> - {canal.nomCanal}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Observaciones - campo completo ancho */}
                            <div className="form-group">
                                <label>Observaciones</label>
                                <textarea value={formulario.obs} onChange={(e) => setFormulario({...formulario, obs: e.target.value})} maxLength={500} placeholder="Observaciones" rows={3} style={{ width: '100%', resize: 'vertical' }} />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">Cancelar</button>
                                <button type="submit" className="btn btn-guardar">{modoEdicion ? 'Actualizar' : 'Guardar'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FCliente;
